import { __decorate } from "tslib";
import { Component, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import lineEcharts from '@blade-sxp/portrait-center/components/basic-echarts/line-echarts.vue';
import flowEchartConfig from './flowEchartConfig';
import TimeMixin from '@blade-sxp/portrait-center/components/time-mixin.vue';
import { mixins } from 'vue-class-component';
import { isEmpty } from 'lodash';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import NoData from '@blade-sxp/portrait-center/pages/components/no-data/index.vue';
import { getFuncVisitorTrend } from '@blade-sxp/portrait-center/utils/common-request';
let default_1 = class default_1 extends mixins(TimeMixin) {
    dates;
    zoneType;
    dataX = [];
    recordMode = 'VISIT_USER_COUNT';
    isLoading = false;
    trfficeEchartData = flowEchartConfig(this);
    peopleEchartsData = [[], []];
    isNoData = true;
    timeInterval = '1d'; // 1h & 1d
    timeDateOption = [
        { label: `${this.$t('hour')}`, value: '1h' },
        { label: `${this.$t('day')}`, value: '1d' },
    ];
    get showTimeDate() {
        return this.sourceType === 'VISIT_OFFLINE_COUNT';
    }
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    get sourceType() {
        let value = '';
        if (this.recordMode === 'VISIT_USER_COUNT') {
            if (this.zoneType === 'MAP') {
                value = 'VISIT_USER_COUNT';
            }
            else if (this.zoneType === 'VIRTUAL_AREA') {
                value = 'VA_VISIT_USER_COUNT';
            }
        }
        else if (this.recordMode === 'VISIT_OFFLINE_COUNT') {
            value = 'VISIT_OFFLINE_COUNT';
        }
        return value;
    }
    onUpdateTimeInterval() {
        this.fetchData();
    }
    onChangeDates() {
        this.fetchData();
    }
    onChangeZoneId() {
        this.fetchData();
    }
    mounted() {
        this.fetchData();
    }
    fetchData() {
        this.isNoData = true;
        this.reset();
        if (this.zoneId === 0) {
            return false;
        }
        this.isLoading = true;
        getFuncVisitorTrend({
            businessId: this.zoneId,
            dateStart: this.dates[0],
            dateEnd: this.dates[1],
            attributeType: 'RETURNED_VISITOR_COUNT',
            sourceType: this.sourceType,
            zoneType: this.zoneType,
            timeInterval: this.sourceType === 'VISIT_OFFLINE_COUNT' ? this.timeInterval : '',
        })
            .then((res) => {
            if (res.length > 0) {
                this.setData(res);
            }
        })
            .catch((e) => {
            this.$message.error(e.message || `${this.$t('common.serverError')}`);
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    setData(resData) {
        if (isEmpty(resData)) {
            return;
        }
        this.isNoData = false;
        this.dataX = [];
        let calm = [];
        resData[0]?.data?.['RETURNED_VISITOR_COUNT']?.forEach((element) => {
            this.dataX.push(element.time);
            calm.push(element.value || 0);
        });
        this.peopleEchartsData = [calm];
    }
    reset() {
        this.peopleEchartsData = [[], []];
        this.dataX = [];
    }
};
__decorate([
    Prop()
], default_1.prototype, "dates", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneType", void 0);
__decorate([
    Watch('timeInterval')
], default_1.prototype, "onUpdateTimeInterval", null);
__decorate([
    Watch('dates')
], default_1.prototype, "onChangeDates", null);
__decorate([
    Watch('zoneId')
], default_1.prototype, "onChangeZoneId", null);
default_1 = __decorate([
    Component({
        name: 'returned-customers',
        components: { lineEcharts, 'no-data': NoData },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
